require('./brokerPensionPlanCancelPendingOrderStep1.scss')

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @core
const { FormattedText } = require('core/i18n').i18n;
// @utils
const currencyHelper = require('utilities/currencyHelper');
// @constants
const { EURO_TEXT } = require('constants/index');
// @components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

class BrokerPensionPlanCancelPendingOrderStep1 extends React.Component {
    render() {
        const { clientName, immBrokerContractActivities, contractNumber, movementId, detailsIndex  } = this.props;

        const immMovement = immBrokerContractActivities.getIn([ contractNumber, 'byId', movementId ]);
        const immDetails = immMovement.getIn([ 'details', 'data', 'listaMovPendientesDet', 'movPendienteDet', detailsIndex ]);
        const amount = currencyHelper.formatAmount(immDetails.getIn([ 'importe', 'importe' ], 0));
        const currency = immDetails.getIn([ 'importe', 'divisa' ], EURO_TEXT);
        const pensionPlanName = immDetails.getIn([ 'cancelDetails', 'planDescripcion' ], '').trim();
        const pensionPlanOwner = immDetails.getIn([ 'cancelDetails', 'nombreTitular' ], '').trim();

        return (
            <article className="broker-pension-plan-cancel-pending-order-step1">
                <header className="wizard_header">
                    <h1 className="wizard-step--vertical__title">
                        <FormattedText value="cancelPensionPlanPendingOrderStep1-title"/>
                    </h1>
                </header>

                <BlockInfo extraClass="broker-pension-plan-cancel-pending-order-step1__prompt">
                    <p>
                        <FormattedText
                            value="cancelPensionPlanPendingOrderStep1-disclaimerText1"
                            injectedStrings={[ clientName ]}
                        />
                    </p>
                    <p>
                        <FormattedText
                            value="cancelPensionPlanPendingOrderStep1-disclaimerText2"
                            injectedStrings={[ amount, currency, pensionPlanName, contractNumber, pensionPlanOwner ]}
                        />
                    </p>
                    <p>
                        <FormattedText
                            value="cancelPensionPlanPendingOrderStep1-disclaimerText3"
                            injectedStrings={[ clientName ]}
                        />
                    </p>
                </BlockInfo>
            </article>
        );
    }
}

BrokerPensionPlanCancelPendingOrderStep1.propTypes = {
    immBrokerContractActivities: PropTypes.object.isRequired,
    contractNumber: PropTypes.string.isRequired,
    movementId: PropTypes.string.isRequired,
    detailsIndex: PropTypes.string.isRequired,
    clientName: PropTypes.string.isRequired,
};

module.exports = BrokerPensionPlanCancelPendingOrderStep1;
